import { ref, onMounted } from 'vue';
import { useScroll } from '@vueuse/core';

export function useScrollProgress() {
  const { y } = useScroll(window, { throttle: 10 });
  const documentProgress = computed(()=>y.value / document.documentElement.clientHeight);
  return { documentProgress };
}
